import * as React from 'react';

export default function ChatLightningIcon(props) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M2.5 21.05V4.3c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525h15.4c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v11.4c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525H6.05L2.5 21.05zM4 17.425L5.425 16H19.7a.29.29 0 00.213-.088A.289.289 0 0020 15.7V4.3a.292.292 0 00-.087-.213A.292.292 0 0019.7 4H4.3a.289.289 0 00-.212.087A.29.29 0 004 4.3v13.125zM4 4.3V4v13.425V4.3z"
        fill="currentColor"
      />
      <path
        d="M11.818 10.91V15L15 9.273h-2L14.546 6H10v4.91h1.818z"
        fill="currentColor"
      />
    </svg>
  );
}
